// extracted by mini-css-extract-plugin
export default {"register-table__wrapper":"RegisterSparePartTable_register-table__wrapper__a+SwQ","dropdown__wrapper":"RegisterSparePartTable_dropdown__wrapper__xKZRS"};